import React, { useContext, createContext, useState, useMemo, useCallback } from 'react';
export const PopupContext = /*#__PURE__*/createContext(undefined);
const PopupContextProvider = ({
  children
}) => {
  const [popups, setPopups] = useState([]);
  const [popupsPrevLength, setPopupsPrevLength] = useState(0);
  const setPrevLength = useCallback(() => {
    setPopupsPrevLength(popups.length);
  }, [popups]);
  const value = useMemo(() => ({
    popups,
    setPopups,
    popupsPrevLength,
    setPopupsPrevLength,
    setPrevLength
  }), [popups, popupsPrevLength, setPrevLength]);
  return /*#__PURE__*/React.createElement(PopupContext.Provider, {
    value: value
  }, children);
};
export default PopupContextProvider;
export const usePopupContext = () => useContext(PopupContext);